var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.1 17.2 4 6.3c.7 1.1 2.1 1.4 3.2.7s1.4-2.1.7-3.2l-3.3-5 3.2-5.1c.7-1.1.4-2.5-.7-3.2-.4-.2-.8-.4-1.2-.4-.8 0-1.5.4-1.9 1.1l-4 6.3c-.5.8-.5 1.8 0 2.5"
  })));
};
export default SvgChevronLeft;